/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Avoid_Duplicates_HelpInputs */

const en_ad_avoid_duplicates_help = /** @type {(inputs: Ad_Avoid_Duplicates_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When enabled, the AI will return an empty script rather than repeat itself when nothing new is happening on screen.`)
};

const fr_ad_avoid_duplicates_help = /** @type {(inputs: Ad_Avoid_Duplicates_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lorsqu'elle est activée, l'IA renverra un script vide au lieu de se répéter lorsqu'il ne se passe rien de nouveau à l'écran.`)
};

const de_ad_avoid_duplicates_help = /** @type {(inputs: Ad_Avoid_Duplicates_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn diese Funktion aktiviert ist, gibt die KI ein leeres Skript zurück, anstatt sich zu wiederholen, wenn nichts Neues auf dem Bildschirm passiert.`)
};

const it_ad_avoid_duplicates_help = /** @type {(inputs: Ad_Avoid_Duplicates_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando abilitata, l'IA restituirà uno script vuoto anziché ripetersi quando non accade nulla di nuovo sullo schermo.`)
};

const ru_ad_avoid_duplicates_help = /** @type {(inputs: Ad_Avoid_Duplicates_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`При включении этой функции ИИ будет возвращать пустой скрипт, а не повторять свои действия, когда на экране ничего нового не происходит.`)
};

const es_ad_avoid_duplicates_help = /** @type {(inputs: Ad_Avoid_Duplicates_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuando está habilitada, la IA devolverá un guion vacío en lugar de repetirse cuando no ocurra nada nuevo en la pantalla.`)
};

const zh_cn2_ad_avoid_duplicates_help = /** @type {(inputs: Ad_Avoid_Duplicates_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启用此功能后，当屏幕上没有新内容发生时，AI 将返回一个空脚本，而不是重复自身。`)
};

const ja_ad_avoid_duplicates_help = /** @type {(inputs: Ad_Avoid_Duplicates_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有効にすると、画面上で新しい出来事が何も起こっていない場合、AIはスクリプトを繰り返すのではなく、空のスクリプトを返します。`)
};

const hi_ad_avoid_duplicates_help = /** @type {(inputs: Ad_Avoid_Duplicates_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जब इसे सक्षम किया जाता है, तो स्क्रीन पर कुछ भी नया न होने पर एआई खुद को दोहराने के बजाय एक खाली स्क्रिप्ट लौटाएगा।`)
};

const pt_pt2_ad_avoid_duplicates_help = /** @type {(inputs: Ad_Avoid_Duplicates_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando ativada, a IA retornará um script vazio em vez de se repetir quando nada de novo estiver acontecendo na tela.`)
};

/**
* | output |
* | --- |
* | "When enabled, the AI will return an empty script rather than repeat itself when nothing new is happening on screen." |
*
* @param {Ad_Avoid_Duplicates_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_avoid_duplicates_help = /** @type {((inputs?: Ad_Avoid_Duplicates_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Avoid_Duplicates_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_avoid_duplicates_help(inputs)
	if (locale === "de") return de_ad_avoid_duplicates_help(inputs)
	if (locale === "it") return it_ad_avoid_duplicates_help(inputs)
	if (locale === "ru") return ru_ad_avoid_duplicates_help(inputs)
	if (locale === "es") return es_ad_avoid_duplicates_help(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_avoid_duplicates_help(inputs)
	if (locale === "ja") return ja_ad_avoid_duplicates_help(inputs)
	if (locale === "hi") return hi_ad_avoid_duplicates_help(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_avoid_duplicates_help(inputs)
	return en_ad_avoid_duplicates_help(inputs)
});